import { ChangePasswordPage } from '@openeducation/oe-it-teacher-portal';
import * as React from 'react';

export const ChangePasswordScreen = () => {
  return <ChangePasswordPage />;
};
